const PEXELS = "?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const DEFAULT_CONTENT = {
  site: {
    name: "Trattoria i Maceri",
    founded: "dal 1996",
    phone: "0547 331606",
    email: "trattoriaimaceri@gmail.com",
    address: "Via Roversano 579, 47521 Cesena (FC)",
  },
  hero: {
    overline: "A pochi passi dal fiume Savio · dal 1996",
    subtitle:
      "Oltre trent'anni di cucina legata al territorio, tra prodotti locali e stagionali, in un giardino a pochi passi dal fiume Savio.",
  },
  images: {
    hero: `https://images.pexels.com/photos/831552/pexels-photo-831552.jpeg${PEXELS}`,
    interior: `https://images.pexels.com/photos/31071253/pexels-photo-31071253.jpeg${PEXELS}`,
    cellar: `https://images.pexels.com/photos/35501239/pexels-photo-35501239.jpeg${PEXELS}`,
  },
  storia: {
    overline: "La nostra storia",
    heading: "Una tavola che racconta il territorio",
    p1: "Da oltre trent'anni la nostra trattoria accoglie chi cerca una cucina sincera, fatta di prodotti locali e stagionali. Un indirizzo discreto e raffinato, amato da professionisti e famiglie, dove il tempo si misura nel piacere della tavola.",
    p2: "Accanto al menù alla carta, ogni giorno la cucina propone piatti extra ispirati al mercato: perché la stagione, qui, si legge nel piatto.",
    features: [
      { icon: "leaf", title: "Prodotti locali e stagionali", text: "Ingredienti scelti ogni giorno dai produttori del territorio, seguendo il ritmo delle stagioni." },
      { icon: "wine", title: "Un'ampia carta dei vini", text: "Una cantina ricca e curata, con etichette del territorio e grandi nomi, pensata per accompagnare ogni piatto." },
      { icon: "sparkles", title: "Piatti fuori carta", text: "Ogni giorno proposte extra che nascono dal mercato del mattino e dalla mano della cucina." },
      { icon: "waves", title: "A pochi passi dal fiume Savio", text: "Il fiume Savio scorre a due passi dal locale: d'estate si cena nel verde cullati dal suo lento scorrere." },
      { icon: "trees", title: "Il giardino", text: "Un ampio giardino ombreggiato accoglie pranzi e cene all'aperto nella bella stagione." },
      { icon: "car", title: "Ampio parcheggio", text: "Un comodo parcheggio riservato rende l'arrivo semplice, anche per comitive ed eventi." },
    ],
  },
  galleria: {
    overline: "Galleria",
    heading: "Il locale, il giardino, il fiume",
    items: [
      { src: `https://images.pexels.com/photos/18823969/pexels-photo-18823969.jpeg${PEXELS}`, alt: "Il giardino della trattoria al calar della sera", caption: "Il giardino", ratio: "aspect-[4/5]" },
      { src: `https://images.pexels.com/photos/31071253/pexels-photo-31071253.jpeg${PEXELS}`, alt: "La sala principale con luci calde", caption: "La sala", ratio: "aspect-[3/4]" },
      { src: `https://images.pexels.com/photos/831552/pexels-photo-831552.jpeg${PEXELS}`, alt: "Il fiume Savio vicino al locale", caption: "Il fiume Savio", ratio: "aspect-[4/3]" },
      { src: `https://images.pexels.com/photos/35501239/pexels-photo-35501239.jpeg${PEXELS}`, alt: "La cantina dei vini", caption: "La cantina", ratio: "aspect-[3/4]" },
      { src: `https://images.pexels.com/photos/17035090/pexels-photo-17035090.jpeg${PEXELS}`, alt: "Tavola apparecchiata all'aperto", caption: "La tavola all'aperto", ratio: "aspect-[4/5]" },
      { src: `https://images.pexels.com/photos/10633476/pexels-photo-10633476.jpeg${PEXELS}`, alt: "Dettaglio degli interni con lampadario", caption: "I dettagli", ratio: "aspect-[4/3]" },
    ],
  },
  orari: {
    overline: "Orari di apertura",
    heading: "Quando trovarci",
    rows: [
      { giorni: "Venerdì — Martedì", orari: "Pranzo 12:00 – 14:30 · Cena 19:00 – 22:30" },
      { giorni: "Mercoledì e Giovedì", orari: "Chiuso" },
    ],
    note: "La cucina chiude 30 minuti prima degli orari indicati.",
  },
  contatti: {
    overline: "Dove siamo",
    heading: "Vicino al fiume, a due passi da tutto",
    parking: "Ampio parcheggio riservato ai clienti, comodo anche per pullman e comitive.",
  },
  preventivi: {
    overline: "Eventi & Gruppi",
    heading: "Richiedi un preventivo",
    intro: "Cene aziendali, cerimonie, ricorrenze: la sala e il giardino accolgono gruppi numerosi con menù studiati su misura.",
    disclaimer: "Questo modulo è riservato esclusivamente a richieste di preventivo per gruppi oltre 15 persone. Per prenotare un tavolo vi aspettiamo al telefono.",
  },
  footer: {
    tagline: "Cucina di territorio a pochi passi dal fiume Savio, dal 1996.",
    bottom: "Ampio parcheggio · Giardino · Fiume Savio",
  },
};
